<template>
    <BaseChip
        class="gst-offer-token-status-chip"
        :class="{
            'gst-offer-token-status-chip--active': isActive,
            'gst-offer-token-status-chip--inactive': isInactive,
        }">
        <span class="content">{{ name }}</span>
        <slot name="append-inner"> </slot>
    </BaseChip>
</template>

<script>
import offerTokenStatusesConstants from '@utils/constants/offerTokenStatuses';
import BaseChip from './BaseChip.vue';

export default {
    name: 'offerTokenStatusChip',
    components: {
        BaseChip,
    },
    props: {
        params: {
            type: Object,
            required: true,
        },
    },
    computed: {
        value() {
            return (this.params?.value || '').toUpperCase();
        },

        isActive() {
            return this.value === offerTokenStatusesConstants.ACTIVE;
        },

        isInactive() {
            return this.value === offerTokenStatusesConstants.INVALID;
        },

        name() {
            return this.$t(`_common:entities.offerTokenStatus.items.${this.value.toLowerCase()}`);
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@scssVariables';

.gst-offer-token-status-chip {
    border-radius: 4px;
    .content:before {
        vertical-align: middle;
        font: bold 1.5em/0 monospace;
        content: '\2022';
        margin-right: theme-spacing(2);
        line-height: 1.1;
    }
}

.gst-offer-token-status-chip--active {
    background-color: rgba(theme-color-hex('statusSuccess'), 0.2) !important;

    .content:before {
        color: theme-color('statusSuccess');
    }
}

.gst-offer-token-status-chip--inactive {
    background-color: rgba(theme-color-hex('septenary'), 0.1);
    color: theme-color('septenary');

    .content:before {
        color: theme-color('septenary');
    }
}
</style>
